import Glide from "@glidejs/glide";

function initGlideCarousel() {
  if (document.querySelector(".glide")) {
    new Glide(".glide").mount();
  }
}

export default initGlideCarousel;
